import React from "react";

import { useRootAppStore } from "@hooks";
import classNames from "classnames";

type WalletIcon_Props = {
	bettingAccountTypeAbrv?: string | null;
	classList?: string;
	iconSize?: string;
	marginReset?: boolean;
	isWalletManuallyDisabled?: boolean;
};

export const WalletIcon = function WalletIcon(props: WalletIcon_Props) {
	const user = useRootAppStore().userAuthStore;

	const numberOfUsersWallets = user.userAccounts?.length;

	if (props.bettingAccountTypeAbrv === "" || numberOfUsersWallets == 1) {
		return null;
	}

	let iconClasses = classNames(
		"u-icon",
		{
			"u-icon--sml": props.iconSize == null,
			"u-mar--reset": props.marginReset,
		},
		props.iconSize,
		[`u-icon--wallet u-icon--wallet--${props.bettingAccountTypeAbrv}`],
		{
			"is-disabled": props.isWalletManuallyDisabled,
		},
		props.classList
	);

	return <i className={iconClasses} />;
};
